import jwtService from "./jwtService.js";
import React from "react";
import { Component } from "react";
import messageService from "src/App/services/MessageService.js";
import WarningToast from "src/App/components/Toasts/WarningToast";
import { toast } from "react-toastify";

export default class BaseResourceService extends Component {
  find = async (url) => {
    let response = await jwtService.getInterceptor().get(url);
    return response;
  };

  async get(url, config = undefined) {
    let response = undefined;
    if(config) {
      response = await jwtService.getInterceptor().get(url, config);
    } else {
      response = await jwtService.getInterceptor().get(url);
    }
    return response;
  }

  async getBlob(url) {
    return await jwtService.getInterceptor().get(url, { responseType: "blob" });
  }

  delete = async (url) => {
    let response = await jwtService.getInterceptor().delete(url);
    return response;
  };

  saveOrUpdate = async (url, data) => {
    let response;
    if (data.codigo)
      response = await jwtService
        .getInterceptor()
        .put(url + `/${data.codigo}`, data);
    else response = await jwtService.getInterceptor().post(url, data);
    return response;
  };

  saveOrUpdateFormData = async (url, data, codigo) => {
    let response;
    if (codigo)
      response = await jwtService
        .getInterceptor()
        .put(url + `/${codigo}`, data);
    else response = await jwtService.getInterceptor().post(url, data);
    return response;
  };

  async post(url, data) {
    let response = await jwtService.getInterceptor().post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  }

  async update(url, data) {
    let response = await jwtService.getInterceptor().put(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  }

  patch = async (url, data) => {
    let response = await jwtService.getInterceptor().patch(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  };

  getAll = (endpoint, params) => {
    let url = this.addParamsToUrl(`/${endpoint}`, params);
    return new Promise((resolve, reject) => {
      this.get(url)
        .then((response) => {
          if (response && response.status === 200) {
            const data = response.data;
            if (Array.isArray(data)) {
              resolve(data);
              return;
            }
            if (data === "" || data === null || typeof data === "undefined") {
              resolve([]);
              return;
            }
            resolve(data);
          } else if (response && response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error && error.response ? error.response : error);
        });
    });
  }

  salvarModelo = (endpoint, modelo) => {
    return new Promise((resolve, reject) => {
      this.saveOrUpdate(`/${endpoint}`, modelo)
        .then((response) => {
          if (response && response.data) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  };

  salvarModeloFormData = (endpoint, modelo, codigo) => {
    return new Promise((resolve, reject) => {
      this.saveOrUpdateFormData(`/${endpoint}`, modelo, codigo)
        .then((response) => {
          if (response && response.data) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  };

  findModelo = (endpoint, codigo) => {
    return new Promise((resolve, reject) => {
      this.find(`/${endpoint}/${codigo}`)
        .then((response) => {
          if (response && response.data) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  };

  addParamsToUrl(url, params) {
    if (params != null) {
      params.forEach((param, index) => {
        if (index === 0) url = url + "?";
        url = url + `${param["chave"]}=${param["valor"]}`;
        if (index + 1 !== params.length) url = url + "&";
      });
    }
    return url;
  }

  // Monta a mensagem de erro de transmissão de nota priorizando a versão amigável
  // (auto-suporte) e mantendo o código + texto original da SEFAZ de forma secundária,
  // para o usuário repassar ao suporte/contador quando precisar.
  montarMensagemErroNota(mensagemAmigavel, codigoRetorno, mensagemSefaz) {
    const amigavel = (mensagemAmigavel || "").trim();
    const sefaz = (mensagemSefaz || "").trim();

    // Sem amigável (código não mapeado): usa o texto da SEFAZ como antes.
    if (!amigavel || amigavel === sefaz) {
      return sefaz || "Erro na transmissão da nota";
    }

    // O backend agora separa a mensagem amigável (mensagemAmigavel) do texto
    // técnico cru (mensagemRetorno). Mas a parte amigável pode chegar com o
    // "(Detalhe da SEFAZ: ...)" já embutido em alguns fluxos — nesse caso
    // exibe como veio, sem re-montar, para não duplicar (reprovação 19312).
    const limpa = (txt) => (txt || "").replace(/\s*\(?detalhe da sefaz:.*$/is, "").trim();
    const amigavelLimpa = limpa(amigavel);

    // Detalhe técnico da SEFAZ (código + motivo original), em segunda linha —
    // montado UMA única vez a partir do texto técnico cru.
    const sefazLimpo = limpa(sefaz);
    const partesDetalhe = [];
    if (codigoRetorno) partesDetalhe.push(`código ${codigoRetorno}`);
    if (sefazLimpo) partesDetalhe.push(sefazLimpo);
    const detalhe = partesDetalhe.join(" - ");

    return detalhe ? `${amigavelLimpa}\n\nDetalhe da SEFAZ: ${detalhe}` : amigavelLimpa;
  }

  tratarErrosToast(error, toastId) {
    if(!toastId) {
      toastId = messageService.successMessage(<WarningToast texto={""} />, {
        toastId: "errorId",
        position: "top-center",
          autoClose: false,
        });
    }

    let mensagemErro = "Erro desconhecido";

    if (error && error.data) {
      if (error.data.errors && error.data.errors.length > 0)
        mensagemErro = error.data.errors[0].message;
      else if (error.data.message) mensagemErro = error.data.message;
    } else if (error && error.message) {
      mensagemErro = error.message;
    } else if (error && error.statusText) {
      mensagemErro = `Erro ${error.status}: ${error.statusText}`;
    }

    const mensagemNormalizada = (mensagemErro || "").toLowerCase();

    if (mensagemNormalizada.includes("failed to fetch") || mensagemNormalizada.includes("networkerror")) {
      console.warn("Conexão local indisponível (Failed to fetch). Mensagem detalhada suprimida.");
      return;
    }

    if (typeof mensagemErro === "string" && mensagemErro.includes("USE_AGENT_FOR_A3")) {
      return;
    }

        messageService.updateToast(toastId, {
      render: <WarningToast texto={mensagemErro} />,
      position: "top-center",
          autoClose: false,
      type: toast.TYPE.WARNING,
        });

      console.log("=== MENSAGEM DE ERRO ===");
    console.error(mensagemErro);

    if(error && error.data){
      const errorMessage = error.data.errors ? error.data.errors[0].message : error.data.message;
      
      console.log("=== MENSAGEM DE ERRO ===");
      console.error(errorMessage);

      if (!(typeof errorMessage === "string" && errorMessage.includes("USE_AGENT_FOR_A3"))) {
        messageService.errorMessage(errorMessage, {
          duration: 7000,
          pauseOnHover: true
        });
      }
    } else {
      // Erro genérico se não houver dados específicos
      console.log("Erro:", error);
      messageService.errorMessage("Erro na transmissão da NFCe", {
        duration: 7000,
        pauseOnHover: true
      });
    }
  }
}
